import React from 'react';
import { getContextFromProps } from '../getContextFromProps';
var defaultUserContext = {
    groupRequestsActions: undefined,
    groupRequestsResponse: undefined,
    groupRequestsStatus: undefined,
};
export var GroupRequestsContext = React.createContext(defaultUserContext);
export var GroupRequestsContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var _value = getContextFromProps(value, defaultUserContext);
    return (React.createElement(GroupRequestsContext.Provider, { value: _value }, children));
};
GroupRequestsContextProvider.displayName = 'GroupRequestsContextProvider';
//# sourceMappingURL=GroupRequestsContext.js.map